"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var free_text_1 = __importDefault(require("../../_helpers/free-text"));
var button_1 = __importDefault(require("../../atoms/button"));
var heading_1 = __importDefault(require("../../atoms/heading"));
var icon_1 = __importDefault(require("../../atoms/icon"));
var link_1 = __importDefault(require("../../atoms/link"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var getHelpLink = function (link) {
    if (!link) {
        return undefined;
    }
    if (typeof link === 'string') {
        link = { href: link, target: '_blank' };
    }
    return (React.createElement(LearnMore, null,
        React.createElement(link_1.default, __assign({}, link),
            "Learn More ",
            React.createElement("i", null))));
};
var EmptyState = function (_a) {
    var link = _a.link, helpUrl = _a.helpUrl, title = _a.title, icon = _a.icon, action = _a.action, props = __rest(_a, ["link", "helpUrl", "title", "icon", "action"]);
    var helpLink = getHelpLink(link || helpUrl);
    return (React.createElement(EmptyState.Element, __assign({}, automation_attribute_1.default('empty-state'), props),
        React.createElement(Title, { size: 1 }, title),
        React.createElement(EmptyState.Body, null,
            React.createElement(icon_1.default, { name: icon, size: 110, color: "blue" }),
            React.createElement(free_text_1.default, __assign({}, props, { useParagraph: true })),
            helpLink),
        action && (React.createElement(button_1.default, { size: "large", appearance: "cta", icon: action.icon, onClick: action.handler }, action.label))));
};
EmptyState.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  width: 100%;\n  text-align: center;\n"], ["\n  ", ";\n  width: 100%;\n  text-align: center;\n"])), container_styles_1.default);
EmptyState.Body = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 400px;\n  margin: 0 auto ", " auto;\n\n  > ", " {\n    margin-bottom: ", ";\n    line-height: 1em;\n    opacity: 0.2;\n  }\n"], ["\n  max-width: 400px;\n  margin: 0 auto ", " auto;\n\n  > ", " {\n    margin-bottom: ", ";\n    line-height: 1em;\n    opacity: 0.2;\n  }\n"])), tokens_1.spacing.small, icon_1.default.Element, tokens_1.spacing.xsmall);
var Title = styled_1.default(heading_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0 0 ", " 0;\n"], ["\n  margin: 0 0 ", " 0;\n"])), tokens_1.spacing.xlarge);
var LearnMore = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  i {\n    position: relative;\n    left: 2px;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 4px 0 4px 6px;\n    border-color: transparent transparent transparent ", ";\n  }\n  &:hover i\u00A0 {\n    border-color: transparent transparent transparent ", ";\n  }\n"], ["\n  display: inline-block;\n  i {\n    position: relative;\n    left: 2px;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 4px 0 4px 6px;\n    border-color: transparent transparent transparent ", ";\n  }\n  &:hover i\u00A0 {\n    border-color: transparent transparent transparent ", ";\n  }\n"])), tokens_1.colors.link.default, tokens_1.colors.link.defaultHover);
EmptyState.displayName = 'EmptyState';
exports.default = EmptyState;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=empty-state.js.map